import { Button } from '@synergy-marine-group/synergy-ui';
import { Field, FieldArray } from 'formik';
import React, { useEffect, useState } from 'react';
import InputFieldComponent from '../common/FormComponents/InputFieldComponent';
import closeIcon from '../../images/icons/cross.svg';
import polygon from '../../images/icons/polygon.svg';

const checkCrewError = ({ touched, errors, fieldName, index }) => {
  if (touched?.[index]?.[fieldName] && errors?.[index]?.[fieldName]) {
    return errors?.[index]?.[fieldName];
  }
  return '';
};

const DateofService = ({ values, errors, touched }) => {
  const [isAddbtndisabled, setisAddbtndisabled] = useState(false);
  const [openDate, setopenDate] = useState(true);
  const [disableHeader, setdisableHeader] = useState(false);

  useEffect(() => {
    if (values?.dateOfService?.[0]?.dateOfServices || values?.dateOfService?.length === 0) {
      setisAddbtndisabled(false);
    } else {
      setisAddbtndisabled(true);
    }
  }, [values?.dateOfService]);
  useEffect(() => {
    // eslint-disable-next-line array-callback-return
    values?.purchaseOrderCrew.map((crew) => {
      if (crew?.invoiceStatus?.toLowerCase().includes('payment') || crew?.invoiceStatus?.toLowerCase().includes('voucher') || crew?.invoiceStatus?.toLowerCase().includes('transferred')) {
        setdisableHeader(true);
      }
    });
  }, [values]);
  return (
    <FieldArray
      name="dateOfService"
      render={(arrayHelpers) => (
        <div className="my-4">
              <div
                onClick={() => { return setopenDate(!openDate); }}
                className="flex flex-row place-content-between mb-4  mt-4 bg-secondary-500 p-1 px-2.5 rounded-md  cursor-pointer"
              >
          <div className="text-base font-muli text-white-light  font-bold">Date Of Service</div>
            <img src={polygon} alt="polygon" className={`${!openDate ? 'transform -rotate-90' : ''} w-6`} />
              </div>
          {openDate && (
          <div className="">
            {values?.dateOfService && values?.dateOfService?.length > 0 ? (
              values.dateOfService.map((crew, index) => (
                <>
                  <div className="flex flex-row items-stretch gap-8 my-2">
                    <Field
                    name={`dateOfService[${index}].dateOfServices`}
                    component={InputFieldComponent}
                    index={index}
                    rounded
                    disabled={disableHeader}
                    type="date"
                    />
                    <div className="flex flex-row items-start gap-4" style={{ marginTop: '3.2px' }}>
                     <button
                      type="button"
                      className="custom-secondary-btn ml-auto"
                      style={{ height: '100%' }}
                      hidden={disableHeader}
                      onClick={() => arrayHelpers.remove(index)}
                     >
                      <img src={closeIcon} alt="plus_icon" />
                     </button>
                    </div>
                  </div>
                  <div className="error text-xs" style={{ position: 'static' }}>
                    {checkCrewError({
                      touched,
                      errors,
                      index,
                      fieldName: 'dateOfServices'
                    })}
                  </div>
                </>
              ))
            ) : (
              <div />
            )}
          </div>
          )}
          {openDate && (
          <div className="pt-4 pb-4 ">
            <Button
              type="button"
              className="w-full rounded-md bg-amber-100"
              style={{ color: 'black' }}
              hidden={disableHeader}
              onClick={() => arrayHelpers.push({ dateOfServices: '' })}
              disabled={isAddbtndisabled}
              size="large"
              variant="filled"
            >
              Add
            </Button>
          </div>
          )}
        </div>
      )}
    />
  );
};

export default DateofService;
